import { Observable } from 'rxjs/index';
import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/internal/operators';
import { MatSnackBar } from '@angular/material';
import { ApplicationService } from '../services/application.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  loggedInUser: any;
  constructor(private router: Router, private application: ApplicationService, private route: ActivatedRoute, private snackBar: MatSnackBar) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> | any {
    this.loggedInUser = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser')) : null;
    let token: string;
    if (!isNullOrUndefined(this.loggedInUser) && !isNullOrUndefined(this.loggedInUser.currentToken)) {
      token = this.loggedInUser.currentToken;

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
    }

    return next.handle(request).pipe(
      tap((data) => data, (error) => {
        this.application.isBlocked = false;
        let errMsg: string;
        if (error instanceof HttpErrorResponse) {
          errMsg = `${error.status} - ${error.statusText || ''} ${error.message}`;
        } else {
          errMsg = error.message ? error.message : error.toString();
        }
        if (error.statusText === 'Unauthorized') {
          localStorage.removeItem('currentUser');
          this.router.navigate(['/login']);
          this.application.isBlocked = false;
        }
        if (error.status === 401) {
          this.router.events.subscribe((_: NavigationEnd) => {
            const alreadySetRoute: string = localStorage.getItem('navigationRoute');
            if (isNullOrUndefined(alreadySetRoute) || alreadySetRoute === '') {
              localStorage.setItem('navigationRoute', _.url);
            }
          });

          if (window.location.href.includes('orders') && !window.location.href.includes('order-history') && !window.location.href.includes('pending-location-orders')) {
            sessionStorage.setItem('goToOrderHistoryScreen', `${window.location.origin}/orders/${window.location.href.split('/')[window.location.href.split('/').length - 1]}`);
          }
          localStorage.removeItem('currentUser');
          this.router.navigate(['/login']);
          this.application.isBlocked = false;
        }
        if (error.statusText === 'Unknown Error') {
          this.application.isOffline = true;
          this.application.isBlocked = false;
        }

        if (error.status === 403) {
          this.application.isBlocked = false;
          let errorMessage = 'Access denied. You do not have permission to access this resource.';
          if (error.error && error.error.Message) {
            errorMessage = error.error.Message;
          } else if (error.error && typeof error.error === 'string') {
            errorMessage = error.error;
          }
          this.snackBar.open(errorMessage, 'Close', { duration: 5000 });
          setTimeout(() => {
            this.router.navigateByUrl('/user-dashboard');
          }, 500);
        }

        return error;
      })
    );
  }
}
